<template>
  <div class="doc">
    <yu-head/>
    <div class="container">
      <yu-menu/>
      <yu-article>
        <div class="title">自定义主题</div>
        <div>如果你是采用复制文件这样的安装方式，那么你可以通过修改_varible.scss 来改变主题</div>
        <pre v-highlightjs="code1"><code class="javascript" ></code></pre>

      </yu-article>
    </div>
  </div>
</template>

<script>
import YuHead from './yu-head';
import YuMenu from './yu-menu';
import YuArticle from './yu-article';

export default {
  name: 'Button',
  data() {
    return {
      code1: `
  // 背景颜色
  $primary:#409EFF;
  $success:#67C23A;
  $warming: #e6b322;
  $danger:#F56C6C;
  $info:#909399;
  $background:#f5f7fa;
  $active: #dcdcdc;
  $rem: 50px;
  @function px2rem($px) {
    @return $px/$rem*1rem;
  }

  // 文字颜色
  $dark-text:#303133;
  $text:#606266;
  $light-text:#909399;
  $lighter-text:#C0C4CC;

  // 边框颜色
  $dark-border: #dcdcdc;
  $border:#E4E7ED;
  $light-border:#EBEEF5;
  $lighter-border:#F2F6FC;

  // 字体
  $font-family: "Helvetica Neue",Helvetica,"PingFang SC","Hiragino Sans GB","Microsoft YaHei","微软雅黑",Arial,sans-serif;

  // 字体大小
  $huge:px2rem(20px);
  $big:px2rem(18px);
  $large:px2rem(16px);
  $normal:px2rem(14px);
  $small:px2rem(13px);
  $tiny:px2rem(12px);

  // 控制元素的大小，主要是由height和padding来控制
  // normal和medium用14px字体，small和mini用12px字体
  $normal-height:px2rem(40px);
  $medium-height:px2rem(36px);
  $small-height:px2rem(32px);
  $mini-height:px2rem(28px);

  $sizes:normal, medium, small, mini;
  $size-map: (
    normal: $normal-height,
    medium: $medium-height,
    small: $small-height,
    mini: $mini-height,
  );

  $types:primary, success, warming, info, danger;
  $colors: (
    primary: $primary,
    success: $success,
    warming: $warming,
    danger: $danger,
    info: $info
  );

  $box-shadow:0 2px 12px 0 rgba(0,0,0,.1);
      `,
    };
  },
  components: {
    YuHead,
    YuMenu,
    YuArticle,
  },
};
</script>

<style lang="scss" scoped type="text/scss">
  @import "../assets/css/varible";

  .doc {
    color: $text;
    height: 100%;
    .container {
      width: 1200px;
      margin: 30px auto;
      .title {
        color: $text;
        font-weight: bold;
        padding: 14px 0;
        margin: 20px 0;
        border-bottom: 1px solid $border;
      }
      .sub-title {
        color: $text;
        padding: 0 8px;
        margin: 20px 0;
        border-left: 4px solid $primary;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/theme.vue